export enum ErrorMessage {
  ServerError = 'Internal Server Error',
  NotFound = 'Not Found',
}
